<template>
  <div class='sub-content'>
    <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='product-all-grid'>
      <dx-data-grid ref='refProductInfoListGrid' :data-source='productInfoList' :show-borders='true'
        :showRowLines='true' :showColumnLines='true' :hover-state-enabled="true" :allowColumnResizing='true'
        column-resizing-mode='widget' :allow-column-reordering="true" :height='gridHeight'
        :row-alternation-enabled="false" :focused-row-enabled="true" @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false" key-expr="rowNum" :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing' @cell-prepared="onCellPrepared" @rowPrepared="onRowPrepared">
        <DxSearchPanel :visible="true" placeholder="검색..." />
        <DxFilterRow :visible="true" apply-filter="auto" />
        <DxColumnFixing :enabled="false" />
        <DxColumn :allowEditing='true' caption="순위" data-field="순위">
        </DxColumn>
        <DxColumn v-if="$store.getters.getGroupName !== null" :allowEditing='true'
          :caption="$store.getters.getGroupName" data-field="차종">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="품번" data-field="품번" :min-width="120">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="납입품번" data-field="납입품번">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="품명" data-field="품명" :visible='true'>
        </DxColumn>
        <DxColumn :allowEditing='true' caption="수량" data-field="수량" :visible='true' format='#,##0.00000'
          dataType="number">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="품목유형" data-field="품목유형" :visible='true'>
          <DxLookup :data-source="itemTypeLookup" display-expr="코드명" value-expr="코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="자재유형" data-field="자재유형" :visible='true'>
          <DxLookup :data-source="meterialTypeLookup" display-expr="코드명" value-expr="코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="공정유형" data-field="공정유형" :visible='true'>
          <DxLookup :data-source="processingTypeLookup" display-expr="코드명" value-expr="코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="재질" data-field="재질" :visible='true' width="160">
          <DxLookup :data-source="rawMeterialTypeLookup" display-expr="재질" value-expr="재질" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="단위" data-field="단위" :visible='true'>
          <DxLookup :data-source="unitLookup" display-expr="코드명" value-expr="코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="거래처명" data-field="거래처코드" :visible='true'>
          <DxLookup :data-source="companyInfoList" display-expr="거래처명" value-expr="거래처코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption="납품처명" data-field="납품처코드" :visible='true'>
          <DxLookup :data-source="companyInfoList" display-expr="거래처명" value-expr="거래처코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption='구매/생산담당' data-field="담당부서" :visible='true'
          edit-cell-template="treeGridTemplate">
          <DxLookup :data-source="divisionList" display-expr="부서명" value-expr="부서코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption='생산라인' data-field="라인코드" :visible='true'>
          <DxLookup :data-source="lineListLookup" display-expr="라인명" value-expr="라인코드" />
        </DxColumn>
        <DxColumn :allowEditing='true' caption='도급' data-field="도급" :visible='true'>
        </DxColumn>
        <DxColumn :allowEditing='true' caption="외주가공비" data-field="외주가공비" :visible='true' format='#,##0.00'
          dataType="number">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="구입가" data-field="구입가" :visible='true' format='#,##0' dataType="number">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="판매가" data-field="판매가" :visible='true' format='#,##0' dataType="number">
        </DxColumn>
        <DxColumn :allowEditing='true' caption="파레트적재량" data-field="파레트적재량" :visible='true' format='#,##0'
          dataType="number">
        </DxColumn>
        <DxColumn caption="프레스품 재질 규격" alignment="center">
          <DxColumn :allowEditing='true' caption="CVT" data-field="cvt" :visible='true' format='#,##0'
            dataType="number">
          </DxColumn>
          <DxColumn :allowEditing='true' caption="두께" data-field="두께" :visible='true' format='#,##0.0'
            dataType="number">
          </DxColumn>
          <DxColumn :allowEditing='true' caption="가로" data-field="가로" :visible='true' format='#,##0.0'
            dataType="number">
          </DxColumn>
          <DxColumn :allowEditing='true' caption="세로" data-field="세로" :visible='true' format='#,##0.0'
            dataType="number">
          </DxColumn>
          <DxColumn :allowEditing='true' caption="NET" data-field="net" :visible='true' format='#,##0.00000'
            dataType="number">
          </DxColumn>
          <DxColumn :allowEditing='true' caption="중량" data-field="중량" :visible='true' format='#,##0.00000'
            dataType="number">
          </DxColumn>
        </DxColumn>

        <DxSummary>
          <DxTotalItem value-format='#,##0' show-in-column="품번" display-format="{0} (건)" />
        </DxSummary>
        <dx-paging :enabled="false" />
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false' />
        <dx-sorting mode="none" />
      </dx-data-grid>
    </div>
    <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx"
      style='display: none;'>
    <input id="batch-flle-upload" type="file" @change="onBatchFileUpload($event)" accept=".xlsx"
      style='display: none;'>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div>
  <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling, DxFilterRow, DxColumnFixing, DxTotalItem, DxSorting,
  DxSummary, DxColumn, DxPaging, DxSearchPanel, DxLookup
} from 'devextreme-vue/data-grid'
import ExcelJS from 'exceljs'
import BomBatchModel from '../../share/domain/BomBatchModel'
import axios from 'axios'
import HttpService from '../../share/service/HttpService'

export default {
  name: 'BomBatchReg',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      productInfoList: null,
      focusedRowKey: null,
      itemTypeLookup: null,
      unitLookup: null,
      processingTypeLookup: null,
      companyInfoList: [],
      divisionList: null,
      meterialTypeLookup: null,
      rawMeterialTypeLookup: null,
      lineListLookup: null,
      link: null,
      bomRegBtn: null,
      isValidExcelData: true,
      bomInfoList: null,
      curentTopModel: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxSorting,
    DxScrolling
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.itemTypeLookup.push({ 코드: '필수입력', 코드명: '필수입력' })
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.processingTypeLookup.push({ 코드: '필수입력', 코드명: '필수입력' })
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.meterialTypeLookup.push({ 코드: '필수입력', 코드명: '필수입력' })
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.unitLookup.push({ 코드: '필수입력', 코드명: '필수입력' })
    this.companyInfoList = this.$store.getters.getCompanyInfo
    this.companyInfoList.push({ 거래처코드: '필수입력', 거래처명: '필수입력' })
    let href = `${ConstDef.apiUrl}/fileDownload?file=${ConstDef.BOM_BARCH_FIE_PATH}/${ConstDef.BOM_BATCH_FILE_NMAE}`
    this.link = `<a class="toolbar-label" style='margin:0 10px 0 10px;' href="${href}"><b>등록양식다운로드</b></a>`
    this.refreshRawMeterialLookup()
    this.refreshDivision()
    this.refreshLineInfo()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcWeight (row) {
      if (row.cvt !== null) {
        return row.두께 * row.가로 * row.세로 * ConstDef.스크랩_비중 / 1000000 / row.cvt
      }
      return null
    },
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.value === '필수입력') {
        this.$Q(e.cellElement).css('color', 'blue')
      }
    },
    onDetailFileChange: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      this.goodsInfoList = []
      this.productList = []
      this.pressPriceList = []
      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          const worksheet = workbook.worksheets[0]
          vm.readExcel(worksheet)
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onBatchFileUpload: function ($event) {
      console.log('onBatchFileUpload')
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let form = new FormData()
      const file = $event.target.files[0]
      form.append('file', file)
      form.append('fileName', ConstDef.BOM_BATCH_FILE_NMAE)
      this.$Q('#batch-flle-upload').val('')
      let uploadUrl = '/bomBatchExcelUpload'
      HttpService.upload(form, uploadUrl)
        .then((data) => {
          console.log(data)
          if (data.RESULT === 'SUCCESS') {
            this.$snotify.info('저장 되었습니다')
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    async readExcel (worksheet) {
      let row = null
      let value = null
      this.isValidExcelData = true
      this.bomRegBtn.option({ disabled: true })
      this.productInfoList = []
      this.bomInfoList = []
      this.isLoading = true
      for (let i = 4; i < 500; i++) {
        let isRegHardware = false
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, 1)

        if (value === null) break

        let model = new BomBatchModel()
        model.rowNum = i
        model.순위 = parseInt(value)
        // console.log(model)
        let index = 2
        model.차종 = AppLib.getCellFromExcel(row, index++)
        model.품번 = AppLib.getCellFromExcel(row, index++)

        model.품명 = AppLib.getCellFromExcel(row, index++) // 4
        model.납입품번 = AppLib.getCellFromExcel(row, index++)
        if (model.납입품번 === null) model.납입품번 = model.품번

        value = AppLib.getCellFromExcel(row, index++)
        if (value === null) {
          model.수량 = null
          // console.log('model.수량')
          // this.isValidExcelData = false
        } else {
          model.수량 = parseFloat(value)
        }

        value = AppLib.getCellFromExcel(row, index++)
        model.품목유형 = value === null ? '필수입력' : value.substring(value.lastIndexOf('(') + 1, value.length - 1)
        if (model.품목유형 === '필수입력') {
          console.log('model.품목유형')
          this.isValidExcelData = false
        }
        value = AppLib.getCellFromExcel(row, index++)
        model.자재유형 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)

        if (model.품목유형 === ConstDef.구매품 && (model.자재유형 === ConstDef.부자재 || model.자재유형 === ConstDef.소모품)) {
          // 구매품 등록여부 확인
          await this.$_sp.runNoEncodeFindSqlProc('품목정보', { 품번: model.품번 })
            .then((data) => {
              if (this.$_sp.MakeModel(data).length === 0) {
                isRegHardware = false
              } else {
                isRegHardware = true
              }
            })
        }
        value = AppLib.getCellFromExcel(row, index++)
        model.공정유형 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)

        model.재질 = AppLib.getCellFromExcel(row, index++) // 10
        value = AppLib.getCellFromExcel(row, index++)
        model.단위 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)
        model.구매단위 = model.단위

        value = AppLib.getCellFromExcel(row, index++)
        model.거래처코드 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)

        value = AppLib.getCellFromExcel(row, index++)
        model.납품처코드 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)

        value = AppLib.getCellFromExcel(row, index++)
        model.담당부서 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)

        value = AppLib.getCellFromExcel(row, index++) // 15
        model.라인코드 = value === null ? null : value.substring(value.lastIndexOf('(') + 1, value.length - 1)
        console.log(model.라인코드)
        console.log(value)

        model.도급 = AppLib.getCellFromExcel(row, index++)

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.외주가공비 = isNaN(value) ? null : value

        value = parseInt(AppLib.getCellFromExcel(row, index++))
        model.구입가 = isNaN(value) ? null : value

        value = parseInt(AppLib.getCellFromExcel(row, index++))
        model.판매가 = isNaN(value) ? null : value

        value = parseInt(AppLib.getCellFromExcel(row, index++))
        model.파레트적재량 = isNaN(value) ? null : value

        value = parseInt(AppLib.getCellFromExcel(row, index++))
        model.cvt = isNaN(value) ? null : value

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.두께 = isNaN(value) ? null : value

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.가로 = isNaN(value) ? null : value

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.세로 = isNaN(value) ? null : value

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.net = isNaN(value) ? null : value

        value = parseFloat(AppLib.getCellFromExcel(row, index++))
        model.중량 = isNaN(value) ? null : value

        if (model.품목유형 === null) {
          model.품목유형 = '필수입력'
        } else {
          if (model.품목유형 === ConstDef.구매품) {
            if (!this.validModelPurchase(model, isRegHardware)) {
              console.log('validModelPurchase', model)
              console.log(`validModelPurchase ${this.isValidExcelData}`)
              if (this.isValidExcelData) {
                this.isValidExcelData = false
              }
            }
          } else {
            if (!this.validModelProduct(model)) {
              console.log(`validModelProduct ${this.isValidExcelData}`)
              if (this.isValidExcelData) {
                this.isValidExcelData = false
              }
            }
          }
        }
        if (model.수량 === null) {
          model.수량 = '필수입력'
          this.isValidExcelData = false
        }
        // coding 순서 지킬것
        let parent = null
        if (model.순위 === 0) {
          this.curentTopModel = model
        } else {
          parent = this.bomInfoList[this.bomInfoList.length - 1]
        }
        this.makeBomList(parent, model)
        this.productInfoList.push(model)
      }
      this.isLoading = false
      if (!this.isValidExcelData) {
        this.$snotify.error('필수입력사항 체크후 다시 엑셀등록 하여 주세요.')
      } else {
        const no = this.isDuplicateGoodNo()
        if (no !== null) {
          this.$snotify.error(`중복 품번 = ${no}`, { timeout: 0 })
        } else {
          this.bomRegBtn.option({ disabled: false })
        }
      }
    },
    isDuplicateGoodNo () {
      const maxIndex = this.bomInfoList.length - 1
      for (let i = maxIndex; i > 0; i--) {
        for (let j = i - 1; j > 0; j--) {
          if (this.bomInfoList[j].품번 === this.bomInfoList[i].품번) {
            // console.log(`**********부모순위=${this.bomInfoList[i].품번} index = ${i}`)
            return this.bomInfoList[i].품번
          }
          if (this.bomInfoList[j].순위 < this.bomInfoList[i].순위) {
            break
          }
        }
      }
      return null
    },
    makeBomList (parent, model) {
      let parentNo = model.순위 === 0 ? null : parent.품번
      if (parent !== null && parent.순위 === model.순위) {
        parentNo = parent.상위품번
      } else if (parent !== null && parent.순위 > model.순위) {
        parentNo = this.$_.findWhere(this.bomInfoList, { 순위: model.순위, 최상위품번: this.curentTopModel.품번 }).상위품번
      }
      // console.log(parentNo)

      let temp = {
        순위: model.순위,
        품번: model.품번,
        품명: model.품명,
        수량: model.수량,
        상위품번: parentNo,
        최상위품번: this.curentTopModel.품번,
        품목유형: model.품목유형,
        사용유무: true,
        삭제유무: false,
        createid: this.userInfo.userId,
        updateid: this.userInfo.userId
      }
      // console.log(temp.상위품번)
      this.bomInfoList.push(temp)
    },
    validModelProduct (model) {
      let result = true
      model.자재유형 = null
      if (model.순위 === null) {
        model.순위 = '필수입력'
        // console.log('*******순위')
        result = false
      }
      if (model.품번 === null) {
        model.품번 = '필수입력'
        // console.log('*******품번')
        result = false
      }
      if (model.품명 === null) {
        model.품명 = '필수입력'
        // console.log('*******품명')
        result = false
      }
      if (model.수량 === null) {
        model.수량 = '필수입력'
        // console.log('*******수량')
        result = false
      }
      if (model.공정유형 === null) {
        model.공정유형 = '필수입력'
        // console.log('*******공정유형')
        result = false
      }
      if (model.단위 === null) {
        model.단위 = '필수입력'
        // console.log('*******단위')
        result = false
      }
      // if (model.라인코드 === null) {
      //   model.라인코드 = '필수입력'
      //   // console.log('라인코드')
      //   result = false
      // }
      if (model.도급 === null) {
        model.도급 = '필수입력'
        // console.log('*******도급')
        result = false
      }
      if (model.품목유형 === ConstDef.완제품) {
        if (model.판매가 === null) {
          model.판매가 = 0
          // console.log('판매가')
          // result = false
        }
        if (model.납품처코드 === null) {
          model.납품처코드 = '필수입력'
          // console.log('*******납품처코드')
          result = false
        }
      }
      console.log(model)
      if (model.품목유형 === ConstDef.다공정품 || model.공정유형 === ConstDef.프로그레시브 || model.공정유형 === ConstDef.프레싱 || model.공정유형 === ConstDef.드로잉) {
        if (model.재질 === null) {
          model.재질 = '필수입력'
          // console.log('*******재질') || model.공정유형 === ConstDef.프레싱
          result = false
        }
        if (model.cvt === null) {
          model.cvt = '필수입력'
          // console.log('*******완제품 cvt')
          result = false
        }
        if (model.두께 === null) {
          model.두께 = '필수입력'
          // console.log('*******두께')
          result = false
        }
        if (model.가로 === null) {
          model.가로 = '필수입력'
          // console.log('*******가로')
          result = false
        }
        if (model.세로 === null) {
          model.세로 = '필수입력'
          // console.log('*******세로')
          result = false
        }
        if (model.net === null) {
          model.net = '필수입력'
          // console.log('*******net')
          result = false
        }
        // 프레스 다공정품 상위품목 규격 입력체크
        // const item = this.productInfoList.length > 0 ? this.productInfoList[this.productInfoList.length - 1] : null
        // if (item !== null && item.품목유형 !== ConstDef.구매품 && item.품목유형 === ConstDef.완제품) {
        //   // console.log('다공정 상위품목')
        //   // console.log(item)
        //   if (item.재질 === null) {
        //     item.재질 = '필수입력'
        //     // console.log('*******재질')
        //     result = false
        //   }
        //   if (item.cvt === null) {
        //     item.cvt = '필수입력'
        //     // console.log('*******다공정품 cvt')
        //     result = false
        //   }
        //   if (item.두께 === null) {
        //     item.두께 = '필수입력'
        //     // console.log('*******두께')
        //     result = false
        //   }
        //   if (item.가로 === null) {
        //     item.가로 = '필수입력'
        //     // console.log('*******가로')
        //     result = false
        //   }
        //   if (item.세로 === null) {
        //     item.세로 = '필수입력'
        //     // console.log('*******세로')
        //     result = false
        //   }
        //   if (item.net === null) {
        //     item.net = '필수입력'
        //     // console.log('*******net')
        //     result = false
        //   }
        // }
      }
      if (model.도급 === '도급') {
        if (model.외주가공비 === null) {
          model.외주가공비 = 0
          // console.log('외주가공비')
          // result = false
        }
        if (model.거래처코드 === null) {
          model.거래처코드 = '필수입력'
          // console.log('*******거래처코드')
          result = false
        }
      }
      return result
    },
    validModelPurchase (model, isRegHardware) {
      // console.log(model)
      let result = true
      model.도급 = null
      model.공정유형 = null
      if (model.순위 === null) {
        model.순위 = '필수입력'
        result = false
      }
      if (model.품번 === null) {
        model.품번 = '필수입력'
        result = false
      }
      if (model.품명 === null) {
        model.품명 = '필수입력'
        result = false
      }

      if (model.자재유형 === null) {
        model.자재유형 = '필수입력'
        result = false
      }
      if (isRegHardware === false) {
        if (model.단위 === null) {
          model.단위 = '필수입력'
          result = false
        }
        if (model.거래처코드 === null) {
          model.거래처코드 = '필수입력'
          result = false
        }
        if (model.자재유형 !== ConstDef.외주품 && model.자재유형 !== ConstDef.외주직납품 && model.자재유형 !== ConstDef.자재유형_원자재) {
          if (model.구입가 === null) {
            model.구입가 = 0
            // result = false
          }
        }
        if (model.자재유형 === ConstDef.자재유형_원자재) {
          let size = true
          if (model.재질 === null) {
            model.재질 = '필수입력'
            size = result = false
            console.log('재질')
          }
          if (model.cvt === null) {
            // console.log('구매품 cvt')
            model.cvt = '필수입력'
            console.log('cvt')
            size = result = false
          }
          if (model.두께 === null) {
            model.두께 = '필수입력'
            console.log('두께')
            size = result = false
          }
          if (model.가로 === null) {
            model.가로 = '필수입력'
            console.log('가로')
            size = result = false
          }
          if (model.세로 === null) {
            model.세로 = '필수입력'
            console.log('세로')
            size = result = false
          }
          if (model.net === null) {
            model.net = '필수입력'
            console.log('net')
            size = result = false
          }
          if (size) { // 중량계산
            model.수량 = model.중량
            console.log(model.수량)
          }
        } else {
          if (model.수량 === null) {
            model.수량 = '필수입력'
            result = false
          }
        }
        if (model.자재유형 === ConstDef.외주품 || model.자재유형 === ConstDef.외주직납품) {
          if (model.재질 === null) {
            model.재질 = '필수입력'
            result = false
          }
          if (model.cvt === null) {
            model.cvt = '필수입력'
            result = false
          }
          if (model.두께 === null) {
            model.두께 = '필수입력'
            result = false
          }
          if (model.가로 === null) {
            model.가로 = '필수입력'
            result = false
          }
          if (model.세로 === null) {
            model.세로 = '필수입력'
            result = false
          }
          if (model.net === null) {
            model.net = '필수입력'
            result = false
          }
          if (model.외주가공비 === null) {
            model.외주가공비 = 0
            // result = false
          }
          if (model.자재유형 === ConstDef.외주직납품 && model.납품처코드 === null) {
            model.납품처코드 = '필수입력'
            result = false
          }
        }
      }
      if (result === false) {
        console.log(model)
      }
      return result
    },
    onRowPrepared (e) {
      let color = 'rgb(253, 239, 234)'
      if (e.data !== undefined) {
        if (e.data.순위 === 0) {
          color = 'rgb(255, 142, 142)'
        } else if (e.data.순위 === 1) {
          color = 'rgb(255, 183, 183)'
        } else if (e.data.순위 === 2) {
          color = 'rgb(255, 221, 208)'
        }
        this.$Q(e.rowElement).css('background-color', color)
      }
      /*
      color: rgb(255, 142, 142);
      color: rgb(255, 183, 183);
      color: rgb(255, 221, 208);
      */
    },
    onSelectionChanged (e) {

    },
    onToolbarPreparing (e) {
      let vm = this
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            type: 'default',
            text: '품목/BOM 엑셀파일 선택',
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            type: 'success',
            text: '품목/BOM 저장',
            disabled: true,
            onInitialized: (args) => {
              this.bomRegBtn = args.component
            },
            onClick: (args) => {
              this.$snotify.confirm('품목정보/BOM 저장 하시겠습니까?', '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  {
                    text: '품목저장',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.saveGoodsAndBomAndPrice()
                    }
                  },
                  {
                    text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        },
        {
          location: 'after',
          template: function () {
            return vm.link
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            type: 'default',
            text: '일괄등록용 파일 업로드',
            onClick: (args) => {
              this.$Q('#batch-flle-upload').click()
            }
          }
        }
      )
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
          this.divisionList.push({ 부서명: '필수입력', 부서코드: '필수입력' })
        })
    },
    refreshRawMeterialLookup () {
      this.$_sp.runNoEncodeFindProc('spFindAllRawMeterialLookup', {})
        .then((data) => {
          this.rawMeterialTypeLookup = this.$_sp.MakeModel(data)
          this.rawMeterialTypeLookup.push({ 재질: '필수입력' })
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshLineInfo () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', null)
        .then((data) => {
          this.lineListLookup = this.$_sp.MakeModel(data)
          this.lineListLookup.push({ 라인명: '필수입력', 라인코드: '필수입력' })
        })
    },
    async saveGoodsAndBomAndPrice () {
      // let param구입가 = null
      // let param판매가 = null
      let param재료비 = null
      let sp이월재고 = null
      let spGoodsSave = null
      // let sp구입가 = null
      // let sp판매가 = null
      this.isLoading = true
      for (let i = 0; i < this.productInfoList.length; i++) {
        let sp재료비 = null
        // spGoodsSave = this.$_sp.runInsertOrNoUpdayeSqlProc('품목정보', ['품번'], ['rowNum', '순위', '중량', '수량', 'cvt', '두께', '가로', '세로', 'net', '구입가', '판매가'], [this.productInfoList[i]])
        spGoodsSave = this.$_sp.runUpdateProc('spSaveOrUPdateGoodsInfoByNo', [this.productInfoList[i]])
        console.log(this.productInfoList[i])
        // 월이월원재고
        const 이월재고Param = {
          이월일자: `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`,
          품번: this.productInfoList[i].품번,
          createid: this.userInfo.userId
        }
        // sp이월재고 = this.$_sp.runInsertOrNoUpdayeSqlProc('월이월재고', ['이월일자', '품번'], null, [이월재고Param])
        sp이월재고 = this.$_sp.runUpdateProc('spSaveCurrentStock', [이월재고Param])
        if (this.productInfoList[i].품목유형 === ConstDef.구매품) {
          if (this.productInfoList[i].자재유형 === ConstDef.외주직납품 || this.productInfoList[i].자재유형 === ConstDef.외주품) {
            // const 중량 = this.productInfoList[i].두께 * this.productInfoList[i].가로 * this.productInfoList[i].세로 * ConstDef.스크랩_비중 / 1000000 / this.productInfoList[i].cvt
            param재료비 = {
              품번: this.productInfoList[i].품번,
              cvt: this.productInfoList[i].cvt,
              자사가로: this.productInfoList[i].가로,
              자사세로: this.productInfoList[i].세로,
              자사두께: this.productInfoList[i].두께,
              자사중량: this.productInfoList[i].중량,
              자사NET: this.productInfoList[i].net
            }
            sp재료비 = this.$_sp.runInsertOrUpdayeSqlProc('프레스재료비정보', ['품번'], null, [param재료비])
          }
        } else {
          if (this.productInfoList[i].품목유형 === ConstDef.다공정품 ||
              this.productInfoList[i].공정유형 === ConstDef.프로그레시브 || this.productInfoList[i].공정유형 === ConstDef.프레싱 ||
              this.productInfoList[i].공정유형 === ConstDef.드로잉) {
            param재료비 = {
              품번: this.productInfoList[i].품번,
              cvt: this.productInfoList[i].cvt,
              자사가로: this.productInfoList[i].가로,
              자사세로: this.productInfoList[i].세로,
              자사두께: this.productInfoList[i].두께,
              자사중량: this.productInfoList[i].중량,
              자사NET: this.productInfoList[i].net
            }
            if (this.productInfoList[i].품번.indexOf(':') < 0) {
              sp재료비 = this.$_sp.runInsertOrUpdayeSqlProc('프레스재료비정보', ['품번'], null, [param재료비])
              console.log('프레스재료비정보 업데이트')
              console.log(this.productInfoList[i])
            } else {
              console.log('프레스재료비정보 업데이트 SKIP')
              console.log(this.productInfoList[i])
            }
          }
        }
        // await axios.all([spGoodsSave, sp구입가, sp판매가, sp재료비, sp이월재고])
        await axios.all([spGoodsSave, sp재료비, sp이월재고])
          .then(axios.spread((...reponse) => {
          }))
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
      // BOM정보 저장 : 완제품BOM에 반제품 모두 저정
      console.log(this.bomInfoList)
      await this.$_sp.runUpdateProc('spSaveBomBatch', this.bomInfoList)
        .then((data) => {
          this.$_sp.runUpdateProc('spUpdatePressPurchasePrice', [{ 적용일자: AppLib.getToday() }])
            .then((data) => {
            })
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.updateAllPriceLastDate()
      this.$snotify.info('저장 되었습니다. 새로운 품목이면 외주품 가공비/불량율 확인하여 주세요')
      this.isLoading = false
    },
    updateAllPriceLastDate () {
      this.$_sp.runUpdateProc('spUpdateAllPriceLastDate', [{ null: '' }])
        .then((data) => {
        })
    }

  }
}
</script>

<style lang="scss">
#dd {
  color: rgb(255, 142, 142);
  color: rgb(255, 183, 183);
  color: rgb(255, 221, 208);
  color: rgb(253, 239, 234);
}
</style>
